export const IncrementalDrawContribution = Symbol.for("IncrementalDrawContribution");

export const ArcRender = Symbol.for("ArcRender");

export const Arc3dRender = Symbol.for("Arc3dRender");

export const AreaRender = Symbol.for("AreaRender");

export const CircleRender = Symbol.for("CircleRender");

export const GraphicRender = Symbol.for("GraphicRender");

export const GroupRender = Symbol.for("GroupRender");

export const LineRender = Symbol.for("LineRender");

export const PathRender = Symbol.for("PathRender");

export const PolygonRender = Symbol.for("PolygonRender");

export const RectRender = Symbol.for("RectRender");

export const Rect3DRender = Symbol.for("Rect3DRender");

export const SymbolRender = Symbol.for("SymbolRender");

export const TextRender = Symbol.for("TextRender");

export const RichTextRender = Symbol.for("RichTextRender");

export const Pyramid3dRender = Symbol.for("Pyramid3dRender");

export const GlyphRender = Symbol.for("GlyphRender");

export const ImageRender = Symbol.for("ImageRender");

export const RenderSelector = Symbol.for("RenderSelector");

export const DrawContribution = Symbol.for("DrawContribution");

export const StarRender = Symbol.for("StarRender");
//# sourceMappingURL=symbol.js.map
